import moment from "moment";
import { formatDate } from "../../../../../utils/helpers/date-time/datetime-format";

export const getAvailableMinDateMessage = (date: string) => {
  return `Data available from ${formatDate(date, {
    type: "date",
  })} to ${formatDate(moment(), { type: "date" })}`;
};
